import { render } from "./SupportInstruction.vue?vue&type=template&id=2179d4fe&scoped=true"
const script = {}

import "./SupportInstruction.vue?vue&type=style&index=0&id=2179d4fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2179d4fe"]])

export default __exports__